import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppTextField from '../../../../../components/designe/textfields/app-text-field/AppTextField';
import { useStyles } from './EditManualLoad.styles';

interface IEditManualLoadProps {
  onCancel: () => void;
  onSave: (manualLoad: number | null) => Promise<any>;
  currentValue: number | null;
}

export default function EditManualLoad(props: IEditManualLoadProps) {
  const { onCancel, onSave, currentValue } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const [value, setValue] = useState<string>(
    currentValue !== null && currentValue !== undefined
      ? currentValue.toString()
      : '',
  );
  const [error, setError] = useState<boolean>(false);
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const handleSave = () => {
    setLoader(true);
    const numValue = value.trim() === '' ? null : parseFloat(value);
    onSave(numValue).finally(() => {
      setLoader(false);
    });
  };

  const isDisabled = error || (value.trim() !== '' && parseFloat(value) <= 0);

  return (
    <Box className={classes.editManualLoadWrapper}>
      <Box display="flex" flexDirection="column" gap={1}>
        <AppTextField
          label={t('trainings.load')}
          fullWidth
          type="number"
          inputProps={{
            min: 0,
            step: 'any',
          }}
          value={value}
          error={error}
          helperText={error ? t('trainings.manualLoadError') : ''}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setValue('');
              setError(false);
              return;
            }
            const num = parseFloat(val);
            if (!isNaN(num)) {
              setValue(val);
              setError(num < 0);
            }
          }}
        />
      </Box>

      <Box className={classes.editManualLoadBottom}>
        <AppBarWithButtons
          loading={loader}
          disabled={isDisabled}
          onClick={handleSave}
          onCancelClick={onCancel}
        />
      </Box>
    </Box>
  );
}
